import React, {useState, useEffect} from 'react'
import {
  Table,
  Button,
  Input,
  Modal,
  Spin,
  Row,
  Col,
  Tooltip,
  Popconfirm,
} from 'antd'
import {EditOutlined, SearchOutlined, DeleteOutlined} from '@ant-design/icons'
import apiRequest from '../../hooks/ApiRequest'
import Layouts from '../../components/Layouts'
import BrokerForm from './AddEditAssignMasterBroker'
import {toast} from 'react-toastify'
import CommonSearch from '../../hooks/Search'

const AssignMasterBrokerList = () => {
  const [search, setSearch] = useState('')
  const [insuredUnderwriters, setInsuredUnderwriters] = useState([])
  const [underwriterMasterBrokers, setUnderwriterMasterBrokers] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedID, setSelectedID] = useState(null)
  const [selectedUnderWriterID, setSelectedUnderWriterID] = useState()
  const [selectedMasterBrokerID, setSelectedMasterBrokerID] = useState()

  useEffect(() => {
    fetchAssignedMasterBrokers()
    console.log('modalVisible changed:', modalVisible)
  }, [modalVisible])
  const fetchAllUnderwriters = async () => {
    const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/UsersForDropdown/underwriter`
    const res = await apiRequest(url, 'GET')
    return res?.data || []
  }

  const fetchAssignedMasterBrokers = async () => {
    setLoading(true)
    try {
      const userRole = JSON.parse(localStorage.getItem('roles')) // Assuming it's stored as string
      const loggedInUserId = localStorage.getItem('loggedInUserID')

      if (userRole === 'SuperAdmin') {
        const allUnderwriters = await fetchAllUnderwriters() // API for SuperAdmin
        setInsuredUnderwriters(allUnderwriters)
        const underwriterIds = allUnderwriters.map(u => u.id)
        const resB = await fetchRelations(underwriterIds)
        setUnderwriterMasterBrokers(resB)
      } else {
        // For regular users (Insurer)
        const resU = await fetchRelations([loggedInUserId]) // get underwriters assigned to the logged-in insurer
        setInsuredUnderwriters(resU)

        const underwriterIds = resU.map(item => item.assigneeId)
        const resB = await fetchRelations(underwriterIds) // get master brokers for underwriters
        setUnderwriterMasterBrokers(resB)
      }
    } catch (error) {
      console.error('Error fetching master broker assignments:', error)
      toast.error('Something went wrong')
    } finally {
      setLoading(false)
    }
  }
  const fetchRelations = async payload => {
    const url = `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/GetUserRelationship`
    const res = await apiRequest(url, 'POST', payload)
    if (res?.success) {
      return res.data
    } else {
      return []
    }
  }

  const handleCreate = () => {
    setSelectedID(0)
    setSelectedUnderWriterID(0)
    setSelectedMasterBrokerID(0)
    setModalVisible(true)
  }

  const handleEdit = recordId => {
    const record = underwriterMasterBrokers.find(item => item.id === recordId)
    if (record) {
      setSelectedMasterBrokerID(record.assigneeId)
      setSelectedUnderWriterID(record.assignorId)
      setSelectedID(record.id)
      setModalVisible(true)
    }
  }

  const handleDelete = async (recordId, assigneeId) => {
    try {
      const response = await apiRequest(
        `${process.env.REACT_APP_BASE_URL_AUTH}/api/Auth/DeleteSubordinate/${recordId}/${assigneeId}`,
        'GET',
      )
      if (response.data.success) {
        toast.success('Master Broker assignment deleted successfully')
        await fetchAssignedMasterBrokers()
      } else {
        toast.error(
          response.data.message || 'Failed to delete master broker assignment',
        )
      }
    } catch (error) {
      console.error('Error deleting master broker assignment:', error)
      toast.error('Error deleting master broker assignment')
    }
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchAssignedMasterBrokers()
  }

  const columns = [
    {
      title: 'UnderWriter',
      key: 'underWriterName',
      render: (_, record) => `${record?.assignorName || 'N/A'}`,
    },
    {
      title: 'Master Broker Name',
      key: 'masterBrokerName',
      render: (_, record) => `${record?.assigneeName || 'N/A'}`,
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <>
          <Tooltip title="Edit Assignment">
            <Button type="primary" onClick={() => handleEdit(record.id)}>
              <EditOutlined />
            </Button>
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this claim limit?"
            onConfirm={() => handleDelete(record.id, record.assigneeId)}
            okText="Yes"
            cancelText="No">
            <Tooltip title="Delete">
              <Button type="danger" style={{marginLeft: 8}}>
                <DeleteOutlined />
              </Button>
            </Tooltip>
          </Popconfirm>
        </>
      ),
    },
  ]
  const handleSearch = value => {
    const filterTable = underwriterMasterBrokers.filter(o =>
      Object.keys(o).some(k =>
        String(o[k]).toLowerCase().includes(value.toLowerCase()),
      ),
    )
    setUnderwriterMasterBrokers(filterTable)
  }
  const ClearSerach = () => {
    setSearch('')
    setUnderwriterMasterBrokers(underwriterMasterBrokers)
    fetchAssignedMasterBrokers()
  }
  return (
    <div
      title="Assign Master Broker"
      className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={24} lg={6} xl={12}>
            <div className="section-top-heading">
              <h3
                style={{color: '#0C1362', fontWeight: '600', fontSize: '20px'}}>
                Assign Master Broker to Underwriter
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={5}>
            <CommonSearch
              value={search}
              onChange={e => setSearch(e.target.value)}
              onSearch={handleSearch}
              onClear={ClearSerach}
            />
          </Col>
          <Col xs={10} sm={10} md={6} lg={3} xl={3}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={() => handleSearch(search)}
                style={{marginLeft: 10}}>
                Search
              </Button>
            </div>
          </Col>
          <Col xs={14} sm={14} md={6} lg={5} xl={4}>
            <div className="create-quotation">
              <Button type="primary" onClick={handleCreate}>
                Assign Master Broker
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin size="large" style={{display: 'block', marginTop: 20}} />
      ) : (
        <Table
          columns={columns}
          dataSource={underwriterMasterBrokers}
          rowKey="id"
        />
      )}
      <Modal
        title={
          selectedID ? 'Edit Master Broker Assignment' : 'Assign Master Broker'
        }
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <BrokerForm
          UnderWriterID={selectedUnderWriterID}
          MasterBrokerID={selectedMasterBrokerID}
          recordID={selectedID}
          onSuccess={handleModalClose}
          modalVisible={modalVisible}
        />
      </Modal>
    </div>
  )
}

export default AssignMasterBrokerList
